import React from 'react';
import InlineForm from '@plone/volto/components/manage/Form/InlineForm';
import { Icon, SidebarPortal } from '@plone/volto/components';
import GraduationHatSVG from '@package/svgs/icons/graduation-hat.svg';
import View from './View';
import DegreeProgramBlockSchema from './schema';
import { FormattedMessage } from 'react-intl';

const Edit = (props) => {
  const schema = DegreeProgramBlockSchema(props.intl);
  return (
    <>
      <SidebarPortal selected={props.selected}>
        <InlineForm
          schema={schema}
          title={schema.title}
          icon={<Icon name={GraduationHatSVG} />}
          onChangeField={(id, value) => {
            props.onChangeBlock(props.block, {
              ...props.data,
              [id]: value,
            });
          }}
          formData={props.data}
        />
      </SidebarPortal>
      {props.data.href && props.data.href.length > 0 ? (
        <View data={props.data} isEditMode={true} />
      ) : (
        <div>
          <div>
            <b>
              <FormattedMessage
                id="No degree program or subject selected yet."
                defaultMessage="No degree program or subject selected yet."
              />
            </b>
          </div>
          <span>
            <FormattedMessage
              id="Please select a degree program or subject in the sidebar."
              defaultMessage="Please select a degree program or subject in the sidebar."
            />
          </span>
        </div>
      )}
    </>
  );
};

export default Edit;
